import React from 'react';

import styles from './progress.module.scss';
import clsx from "clsx";

export const Progress = ({progress, className}) => {
  return (
    <div className={clsx(styles.progressBar, className)}>
      <div className={styles.progressLine} style={{ width: progress + '%' }}>
       <span>{progress}%</span>
      </div>
    </div>
  );
};
